import { useWatch } from '@vtex/admin-ui-form'
import { useSalesChannels } from 'hooks'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import type { Item } from 'typings'
import { useFormStateContext } from '../../../providers'
import { MultiSelect } from '../../MultiSelect'

type Props = {
  name: string
}

export function SalesChannelsSelector(props: Props) {
  const { name } = props
  const { formatMessage } = useIntl()
  const { form } = useFormStateContext()

  const items: Item[] = useWatch({ form, name }) ?? []

  const { data: salesChannels, isLoading } = useSalesChannels()

  useEffect(() => {
    const addSalesChannelsName = () => {
      if (!items.length) return

      const updatedValues = items.map((item) => ({
        ...item,
        name:
          salesChannels?.find((salesChannel) => salesChannel.id === item.id)
            ?.name ?? item.name,
      }))

      form.setValue(name, updatedValues)
    }
    !isLoading && addSalesChannelsName()
  }, [isLoading, salesChannels])

  return (
    <MultiSelect
      options={salesChannels ?? []}
      label={formatMessage({
        id: 'admin/promotions.form.sales-channels.selector.label',
      })}
      name={name}
      loading={isLoading}
    />
  )
}
